
import { mapMutations, mapState } from 'vuex'
import QRCodeDialog from './QRCodeDialog.vue'
import CookieSettingDialog from './cookieSetting.vue'
import allUrls from '@/utils/config'
import footer from '@/modules/config/footer'

export default {
  components: { QRCodeDialog, CookieSettingDialog },
  data() {
    return {
      service: footer[this.$route.params.site].service,
      shareSubTitle: footer[this.$route.params.site].shareSubTitle,
      shareSubList: footer[this.$route.params.site].shareSubList,
      iuopUrl: allUrls.iuoploginUrl,
      site: this.$route.params.site,
      lang: this.$route.params.lang,
      shareList: footer[this.$route.params.site].shareList,
      clientWidth: 0,
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      isHdFtMobile: (state) => state.isHdFtMobile,
      productMenus: (state) => state.productMenus,
    }),
    year() {
      return new Date().getFullYear()
    },
    isSc() {
      return /^zh[-_][a-zA-Z]+$/.test(this.locale)
    },
    isFooter150() {
      return this.clientWidth > 1200 && this.clientWidth < 1500
    },
    support() {
      return require(`@/router/${this.site}/support.js`).default || {}
    },
    aboutUs() {
      return require(`@/router/${this.site}/aboutUs.js`).default || {}
    },
    // 韩国站页脚
    footerKr() {
      return require(`@/router/${this.site}/footer.js`).default || {}
    },
    helperList() {
      if (this.site === 'kr') {
        return this.footerKr
      }
      return [
        {
          il8nName: 'navs.logisticsService',
          id: 1,
          children: this.productMenus,
        },
        this.getChildrenPath(this.support),
        this.getChildrenPath(this.aboutUs),
      ]
    },
    jpShareSubList() {
      return footer[this.site].service.otherSite(this.lang)
    },
    getOtherSite() {
      if (process.client) {
        if (window.isHideSFbuy) {
          return (
            this.service
              .otherSite(this.lang)
              // 暂时过滤sfbuy
              .filter((it) => it.name !== 'modules.about.homePageTitles.sfBuy')
          )
        } else {
          return this.service.otherSite(this.lang)
        }
      } else {
        return []
      }
    },
    shareSubClassName() {
      const classes = [];
      const { site, shareList } = this; // 解构更清晰
      if (site === 'vn') {
        classes.push('vn-share-block-sub');
      } else if (site === 'jp') {
        classes.push('jp-share-block-sub');
      } else if (site === 'us' && Array.isArray(shareList) && shareList.length === 0) {
        classes.push('no-divider');
      }
      return classes;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.clientWidth = document.body.clientWidth
    })
    window.onresize = () => {
      this.clientWidth = document.body.clientWidth
    }
    this.lang = this.$route.params.lang
  },
  methods: {
    ...mapMutations({
      setCookieTerms: 'SET_COOKIE_TERMS',
    }),
    routeChange(item) {
      this.$refs.QRCodeDialog.show(item.qrcode, item.text)
    },
    getAboutUrls() {
      return {}
    },
    // cookie 设置
    openCookieDialog() {
      this.setCookieTerms({
        title: this.$t('cookies.cookie'),
        show: true,
        type: 1,
      })
    },
    getChildrenPath(menu) {
      menu.children.map((me) => {
        if (!me.path) {
          me.path = me.children[0].path || ''
        }
        return me
      })
      return menu
    },
    getPopupContainer() {
      return this.$refs.wrapper
    },
    hiddenShareSubFn(it) {
      if (it.hidden) {
        if (it.hidden.lang) {
          return !it.hidden.lang.includes(this.lang)
        }
      }
      return true
    },
  },
}
